import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=3a42fa0e&scoped=true"
import script from "./update-password.vue?vue&type=script&lang=js"
export * from "./update-password.vue?vue&type=script&lang=js"
import style0 from "./update-password.vue?vue&type=style&index=0&id=3a42fa0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules_admin/6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a42fa0e",
  null
  
)

export default component.exports